import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles as styles } from './style/gstheme';

class Locked extends React.Component {

  render() {

    const { classes } = this.props;

    return (
      <Dialog data-test="locked-dialog" open={true} onClose={this.exitWarning} aria-labelledby="locked-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="locked-dialog-title">Project Locked</DialogTitle>
        <DialogContent>
            <DialogContentText data-test={"warning-line"} className={classes.dialogText} paragraph>This project is currently locked due to batch activity.</DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
}

Locked.propTypes = {
  classes: PropTypes.object
};

export default withRouter(withStyles(styles)(Locked));